<template>
<div class="password">
        <OtherHead :tipText="$t('没有访问权限')"></OtherHead>
        <div class="empty_content">
            <img src="@/assets/img/other/password.png" alt=""/>
            <div class="empty_text">{{$t("该文件需要密码")}}</div>
            <div class="password_text">{{$t("密码")}}                <a-input-password class="input_wrap" max-length="16" @press-enter="submit" @input="setPassword" :style="{ width: '184px' }" :placeholder="$t('请输入密码')" allow-clear></a-input-password>
            </div>
            <div v-if="checkCode === 165" class="wrote_pwd_tip">{{$t("请输入正确的密码")}}</div>
            <div class="submit" @click="submit">{{$t("确认")}}</div>
        </div>
    </div>
</template>

<script lang="ts">
import OtherHead from './OtherHead.vue';
import { mapState } from 'vuex';
import { store } from '../../store/store';
import { checkFile } from '../../core/api/file';
export default {
    name: 'no_limit',
    components: {
        OtherHead
    },
    data() {
        return {
            password: ''
        };
    },
    computed: {
        ...mapState({
            checkCode: (state) => state.kbEditModule.checkCode
        })
    },
    methods: {
        setPassword(val) {
            this.password = val;
        },
        async submit() {
            store.dispatch('kbEditModule/setCheckCode', 200);
            //检查文件权限先加载loading
            let doc_id = store.state.kbModule.doc_id;
            let cachePassword = window.localStorage.getItem(`${doc_id}_password`);
            let needPassword =
                this.password != '' ? this.password : cachePassword ? cachePassword : '';
            const res: any = await checkFile(doc_id + '', needPassword);
            const { code, data, message }: any = res?.data || {};
            store.dispatch('kbEditModule/setCheckCode', code);
            if(code !== 165){
                this.$emit('submit_password', this.password);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.password {
    flex: 1;
    display: flex;
    flex-direction: column;

    .empty_content {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        img {
            width: 148px;
        }

        .empty_text {
            height: 25px;
            line-height: 25px;
            font-weight: 600;
            font-size: 18px;
            color: #121317;
            letter-spacing: 0;
            text-align: center;
        }

        .password_text {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 16px;

            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #323233;
            height: 32px;

            .input_wrap {
                margin-left: 8px;
                background: #ffffff;
                border: 1px solid #e6e8ec;
                border-radius: 4px;

                input::placeholder {
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    font-size: 14px;
                    color: #c8c9cc;
                }
            }
        }

        .wrote_pwd_tip {
            margin-top: 16px;
            color: #b33e2f;
            font-size: 14px;
            line-height: 20px;
        }

        .submit {
            cursor: pointer;
            margin-top: 40px;
            width: 138px;
            height: 36px;
            background: #5c70ff;
            border-radius: 6px;
            display: flex;
            align-items: center;
            justify-content: center;

            font-family: PingFangSC-Medium;
            font-weight: 500;
            font-size: 14px;
            color: #ffffff;
        }
    }
}
</style>
